import { createApp } from 'vue'
import App           from './App.vue'
import router        from './router'
import store         from './store'
import axios         from 'axios'
import 'bootstrap/dist/css/bootstrap.css';
import 'jquery/src/jquery.js';
import 'popper.js/dist/popper.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas);
import { fab } from '@fortawesome/free-brands-svg-icons';
library.add(fab);
import { far } from '@fortawesome/free-regular-svg-icons';
library.add(far);
import { dom } from "@fortawesome/fontawesome-svg-core";
// import './registerServiceWorker'
dom.watch();
library.add(faUserSecret)

// axios.defaults.baseURL = 'http://127.0.0.1:8000/';
axios.defaults.baseURL = 'http://176.97.218.214:8000/';

createApp(App).component('font-awesome-icon', FontAwesomeIcon).use(store).use(router).mount('#app')
